/**
 * Bot Operations shows times in ICT (Asia/Bangkok, UTC+7) with the label, because
 * the bots and Grok Bot work in ICT. The rest of the admin uses Denver time.
 */

const FMT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Bangkok',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** "Oct 6 · 00:30 ICT", or "no data" when there is no (valid) time. */
export function fmtIct(iso?: string | null): string {
  if (!iso) return 'no data';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'no data';
  const p: Record<string, string> = {};
  FMT.formatToParts(d).forEach((x) => { p[x.type] = x.value; });
  return `${p.month} ${p.day} · ${p.hour}:${p.minute} ICT`;
}

/** Whole minutes between an ISO time and now, or null. Never negative. */
export function ageMinutes(iso?: string | null, now: number = Date.now()): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.round((now - t) / 60000));
}

/** "3 min", "2 h 5 min", "1 d 4 h". */
export function fmtAge(minutes: number | null): string {
  if (minutes == null) return 'no data';
  if (minutes < 1) return '<1 min';
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  if (h < 24) return `${h} h ${minutes % 60} min`;
  return `${Math.floor(h / 24)} d ${h % 24} h`;
}
